import { GET_USER, LOADING } from "./UserTypes";
const INITIAL_STATE = {
  user: null,
  loading: false,
};
export default function UserReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_USER:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };
    case LOADING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
